import { render, staticRenderFns } from "./MaquinaList.vue?vue&type=template&id=2db747bb&scoped=true"
import script from "./MaquinaList.vue?vue&type=script&lang=js"
export * from "./MaquinaList.vue?vue&type=script&lang=js"
import style0 from "./MaquinaList.vue?vue&type=style&index=0&id=2db747bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db747bb",
  null
  
)

export default component.exports